"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeInputLabelStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeInputLabelStyles = function makeInputLabelStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          marginBottom: primitives.spacings["1"],
          color: tokens.colors["ink-on-background"].rgb
        }, tokens.typography["smallprint"]), {}, {
          maxWidth: "100%",
          "& .DhigInputLabel--hintText": {
            paddingLeft: primitives.spacings["2"],
            color: tokens.colors["ink-on-background-60"].rgb
          },
          "&.Mui-error": {
            color: tokens.colors["ink-on-background"].rgb
          },
          "&.Mui-disabled": {
            opacity: tokens.opacities.disabled.opacity
          }
        }),
        formControl: {
          position: "relative !important",
          // added to avoid applitools differences
          left: "auto",
          top: "auto",
          transform: "none"
        },
        shrink: {
          transform: "none",
          transformOrigin: "unset"
        },
        filled: {
          transform: "none",
          '&[class*="MuiInputLabel-shrink"]': {
            transform: "none"
          },
          marginLeft: primitives.spacings["2"]
        },
        outlined: {
          transform: "none",
          '&[class*="MuiInputLabel-shrink"]': {
            transform: "none"
          }
        }
      }
    }
  };
};

exports.makeInputLabelStyles = makeInputLabelStyles;